import { render, staticRenderFns } from "./AdminAppPaidShowAdd2026.vue?vue&type=template&id=10613ac3&scoped=true"
import script from "./AdminAppPaidShowAdd2026.vue?vue&type=script&lang=js"
export * from "./AdminAppPaidShowAdd2026.vue?vue&type=script&lang=js"
import style0 from "./AdminAppPaidShowAdd2026.vue?vue&type=style&index=0&id=10613ac3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10613ac3",
  null
  
)

export default component.exports